'use client';

import Script from 'next/script';

const ORG_ID = process.env.NEXT_PUBLIC_OPENWIDGET_ORG_ID;

export function OpenWidgetScript() {
  if (!ORG_ID) return null;

  // Full OpenWidget initialization snippet.
  // This sets window.__ow.organizationId, creates window.OpenWidget as a
  // call-queue stub (so callers don't need to wait for the CDN script),
  // then asynchronously loads the CDN script which replaces the stub.
  // Using afterInteractive (a single tag) avoids the race condition that
  // occurred when the CDN script ran before the beforeInteractive init.
  const initScript = `
    window.__ow = window.__ow || {};
    window.__ow.organizationId = "${ORG_ID}";
    (function(n,t,c){
      function i(n){return e._h?e._h.apply(null,n):e._q.push(n)}
      var e={_q:[],_h:null,_v:"2.0",
        on:function(){i(["on",c.call(arguments)])},
        once:function(){i(["once",c.call(arguments)])},
        off:function(){i(["off",c.call(arguments)])},
        get:function(){if(!e._h)throw new Error("[OpenWidget] You can't use getters before load.");return i(["get",c.call(arguments)])},
        call:function(){i(["call",c.call(arguments)])},
        init:function(){var n=t.createElement("script");n.async=!0,n.type="text/javascript",n.src="https://cdn.openwidget.com/openwidget.js",t.head.appendChild(n)}
      };
      !n.__ow.asyncInit&&e.init();
      n.OpenWidget=e;
      t.addEventListener("DOMContentLoaded",function(){i(["init",{}])},!1)
    }(window,document,[].slice));
  `;

  return (
    <Script id="openwidget-init" strategy="afterInteractive">
      {initScript}
    </Script>
  );
}
